<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event.value)"
    [required]="required"
    [disabled]="disabled"
  >
    @for (
      replacementReason of replacementReasonsService.allReplacementReasons$ | async;
      track $index
    ) {
      <mat-option [value]="replacementReason.name">
        {{ replacementReason.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
